import React from "react";
import { CustomerReviewsBlock } from "tsi-common-react/src/components/CustomerReviewsBlock/index";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { buildHomePageBodyComponentsMap } from "../components/HomePageBody";
import { StyleguideChrome } from "../components/StyleguideChrome";
import { offerIndexComponentsMap } from "./OfferIndexPageTemplate";
import { buildProductComparePageComponentsMap } from "./ProductComparePageTemplate";

// The `home` and `product_compare` maps close over page-derived SSR
// side-channels that the styleguide's 3-prop (block/map_key/bg_color) render
// path cannot deliver. The fixtures routed through them carry all their content
// in the serialized block value, so building the maps with zeroed side-channels
// is render-faithful (sealy `pdpComponentsMap` precedent).
const homeComponentsMap = buildHomePageBodyComponentsMap({
    hardcoded_ssr: {},
    hotspot_ssr: {},
    breadcrumbs_ssr: {},
    customer_service_ssr: {},
    shop_compare_ssr: {},
    tab_feature_attribute_ssr: {},
    reviews_ssr: {},
    prequal_enabled_ssr: {},
    reviews_url_ssr: {},
});

const productComparePageComponentsMap = buildProductComparePageComponentsMap({
    hardcoded_ssr: {},
    hotspot_ssr: {},
    breadcrumbs_ssr: {},
    customer_service_ssr: {},
    shop_compare_ssr: {},
    tab_feature_attribute_ssr: {},
    reviews_ssr: {},
});

// tempurpedic never renders the shared CustomerReviewsBlock inside a production
// page StreamField -- so unlike sealy (`toolbox`) / toppers (`home`) there is no
// production component map to route its styleguide fixture through. This
// dedicated map gives the styleguide harness the same React render path,
// keeping it off the per-block Django template chain. The component renders
// entirely from the serialized block value (no page-derived side-channels).
const sharedBlocksComponentsMap = {
    customer_reviews: CustomerReviewsBlock,
};

const registry = {
    toolbox: toolboxComponentsMap,
    home: homeComponentsMap,
    offer_index: offerIndexComponentsMap,
    product_compare: productComparePageComponentsMap,
    shared_blocks: sharedBlocksComponentsMap,
};

const StyleguideBlocks = makeStyleguideTemplate(registry);

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
